import React from 'react';

import GenericCardRenderItems from '../GenericCardRenderItems';

const IngresosOEntradasResumen = ({ data = {} }) => {
  const { IngresosOEntradas = {} } = data;

  return (
    <div className="d-block mt-2 mb-2">
      <GenericCardRenderItems
        data={IngresosOEntradas}
        width={200}
        subtitle="Ingresos obtenidos en el periodo por fideicomisos"
        labels={labels(IngresosOEntradas)}
      />
    </div>
  );
};

const labels = (data = {}) => {
  return [
    {
      label: 'Monto total ingresos',
      index: 'MontTotEntradasPeriodo',
    },
    {
      label: 'Parte proporcional acumulable',
      index: 'PartPropAcumDelFideicom',
    },
    {
      label: 'Proporción del monto total',
      index: 'PropDelMontTot',
    },
    {
      label: 'Descripción del concepto',
      index: 'Concepto',
    },
  ];
};

export default IngresosOEntradasResumen;
